import React, { Component } from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router";
import LearningItemView from "./learningItemView/learningItemView";
import VideoList from "./videoList/videoList";
import MessagePoster from "./messagePoster";
import './app.scss';

class App extends Component {
  render() {
    return (
      <MessagePoster>
        <BrowserRouter>
          <Routes>
            <Route path="/component/learn/videos" element={<VideoList />} exact />
            <Route path="/component/learn/aspnet" element={<LearningItemView baseTag="aspnet" />} exact />
            <Route path="/component/learn/maui" element={<LearningItemView baseTag="maui" />} exact />
            <Route path="/component/learn/ml-dotnet" element={<LearningItemView baseTag="ml-dotnet" />} exact />
            <Route path="/component/learn/csharp" element={<LearningItemView baseTag="csharp" />} exact />
            <Route path="/component/learn/fsharp" element={<LearningItemView baseTag="fsharp" />} exact />
            <Route path="/component/learn/games" element={<LearningItemView baseTag="games" />} exact />
            <Route path="/component/learn/iot" element={<LearningItemView baseTag="iot" />} exact />
            <Route path="/component/learn/microservices" element={<LearningItemView baseTag="microservices" />} exact />
            <Route path="/health" render={() => "Healthy!"} exact />
            <Route path="/" element={<Navigate to="/component/learn/aspnet" />} />
          </Routes>
        </BrowserRouter>
      </MessagePoster>
    );
  }
}

export default App;
